import { axios } from "../axios.instance";

export type GetNotificationsUnreadCounterRequest = null;

export type GetNotificationsUnreadCounterResponse = {
  count: number;
};

export const getNotificationsUnreadCounter = async (): Promise<GetNotificationsUnreadCounterResponse> => {
  const { data } = await axios.get(`/notifications/unread/count`);

  return data;
};
